const TV_USER_AGENT_PATTERN = /Android TV|GoogleTV|SmartTV|Tizen|Web0S|BRAVIA/i;

export function isLikelyTvDevice(userAgent = null) {
  const source =
    typeof userAgent === "string"
      ? userAgent
      : typeof navigator !== "undefined"
        ? navigator.userAgent
        : "";
  return TV_USER_AGENT_PATTERN.test(source || "");
}

export function isRemoteNavPreferred(uiStore = null, userAgent = null) {
  return Boolean(uiStore?.tvMode) || isLikelyTvDevice(userAgent);
}
